"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isType = exports.actionCreator = void 0;
function actionCreator(type) {
    return Object.assign(function (payload) { return ({ type: type, payload: payload }); }, { type: type });
}
exports.actionCreator = actionCreator;
function isType(action, actionCreator) {
    return action.type === actionCreator.type;
}
exports.isType = isType;
